import Button from '@cpg-its/ads.common.button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { EcdStates } from '../../root/ecd-model';
import { buttonStyles } from '../constants/theme/styles/components/buttonStyles';
import { setExternalLinkState } from '../ducks/app-context';
import { handleExternalLinkClick } from '../helpers/url-helper';
import { ExternalLinkState } from '../models/app-context-model';
import { SiteSettingsProps } from '../models/epi-model';
import { ECDModal } from './ecd-modal';
import { ButtonWrapper } from './layout/button-wrapper';

export function ExternalLinkModal() {
    const dispatch = useDispatch();

    const siteSettings = useSelector<EcdStates, SiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);
    const externalLinkState = useSelector<EcdStates, ExternalLinkState>(state => state.appContext?.externalLinkState);

    const handleClose = () => {
        dispatch(setExternalLinkState({
            renderModal: false,
            linkUrl: '',
            linkInnerHtml: '',
        }));
    };

    const handleContinue = () => {
        if (!externalLinkState?.linkUrl) return;

        window.open(externalLinkState?.linkUrl, '_blank');

        dispatch(setExternalLinkState({
            renderModal: false,
            linkUrl: '',
            linkInnerHtml: '',
        }));
    };

    const isRemoteSupportLink = (url: string) => {
        return url?.includes('cpg.support.me');
    };


    return (
        <ECDModal
            open={externalLinkState?.renderModal}
            handleClose={handleClose}
        >
            <>
                <p>{isRemoteSupportLink(externalLinkState?.linkUrl) ? siteSettings?.remoteSupportLinkModalMessage : siteSettings?.externalLinkModalMessage || 'You are leaving this site and will be redirect to another website.'}</p>
                <ButtonWrapper flexEnd>
                    <Button type='button' buttonStyle='tertiary' text={siteSettings?.externalLinkModalCancelButtonText || 'Cancel'} backgroundColor='#808080' onClick={handleClose} />
                    <Button type='button' buttonStyle='primary' onClick={handleContinue} text={siteSettings?.externalLinkModalContinueButtonText || 'Continue'} />                    
                </ButtonWrapper>
            </>
        </ECDModal>
    );
}

interface Props {
    linkText: string | JSX.Element;
    linkUrl: string;
    className?: string;
    linkIcon?: JSX.Element;
    newWindow?: boolean;
    iconRight?: boolean;
    onClickHandler?: () => void;
}
export function ExternalLink(props: Props) {
    const { linkText, linkUrl, className, linkIcon, newWindow, iconRight } = props;

    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const buttonClasses = buttonStyles();

    const handleLinkClick = (e) => {
        if (props?.onClickHandler) props.onClickHandler();
        handleExternalLinkClick(e, dispatch, history, location);
    };
    if (iconRight) {
        return (
            <>
                <a
                    target={newWindow ? '_blank' : ''}
                    rel="noreferrer"
                    href={linkUrl}
                    className={`${className} ${linkIcon && buttonClasses.linkButton}`}
                    onClick={handleLinkClick}><span>{linkText}</span>{linkIcon}</a>
            </>
        );
    }
    return (
        <>
            <a
                target={newWindow ? '_blank' : ''}
                rel="noreferrer"
                href={linkUrl}
                className={`${className} ${linkIcon && buttonClasses.linkButton}`}
                onClick={handleLinkClick}>{linkIcon}<span>{linkText}</span></a>

        </>
    );
}


interface SearchExternalLinkProps {
    linkText: string | JSX.Element;
    linkUrl: string;
    history: any;
    location: any;
    dispatch: any;
    className?: string;
}
export function SearchExternalLink(props: SearchExternalLinkProps) {
    const { linkText, linkUrl, className, history, location, dispatch } = props;

    const handleLinkClick = (e) => {
        handleExternalLinkClick(e, dispatch, history, location);
    };

    return (
        <>
            <a
                href={linkUrl}
                className={className}
                onClick={handleLinkClick}>{linkText}</a>

        </>
    );
}


ExternalLink.defaultProps = {
    className: '',
    linkIcon: '',
    newWindow: false,
    iconRight: false,
    onClickHandler: null,
};

SearchExternalLink.defaultProps = {
    className: '',
};